function injectStyle (ssrContext) {
  require("!!../../node_modules/.pnpm/extract-text-webpack-plugin@1.0.1_webpack@1.15.0/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6587ab68\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/selector?type=styles&index=0!./G-rednav.vue")
}
var Component = require("!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/selector?type=script&index=0!./G-rednav.vue"),
  /* template */
  require("!!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6587ab68\",\"hasScoped\":false}!../../node_modules/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/node_modules/vue-loader/lib/selector?type=template&index=0!./G-rednav.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/G-rednav.vue
// module id = 23
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16